// src/features/auth/login.schema.ts
// Zod validation schema for the login form - email + password only.
import { z } from 'zod'

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .trim()
    .email('Please enter a valid email address')
    .regex(/^[\x21-\x7E]*$/, 'Only English letters, numbers, and standard symbols are allowed (no spaces or emojis)'),

  password: z
    .string()
    .min(1, 'Password is required')
    .min(6, 'Password must be at least 6 characters')
    .regex(/^[\x20-\x7E]*$/, 'Only English letters, numbers, and standard symbols are allowed (no emojis or non-English characters)'),
})

export type LoginFormValues = z.infer<typeof loginSchema>
